export interface AppConfig {
  navigationPrefix: string;
}

export const appConfig: AppConfig = {
  navigationPrefix: '',
};
